import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import LabeledGraphicFormFonts from './LabeledGraphicFormFont'
import LabeledGraphicFormStyle from './LabeledGraphicFormStyle'
import type { LabeledGraphicFormBrandType, LabeledGraphicBrandForms } from './labeledGraphicTypes'

const FORM_MAP: LabeledGraphicBrandForms = {
  [BrandFormEnum.STYLE]: LabeledGraphicFormStyle,
  ...(LabeledGraphicFormFonts as LabeledGraphicBrandForms),
}

const LabeledGraphicFormBrand: LabeledGraphicFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(LabeledGraphicFormBrand) as typeof LabeledGraphicFormBrand
